import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AccountRequest, AuthService } from '../../../services/Auth/auth.service';
import moment from 'moment';
import { MomentFormatPipe } from "../../../moment.pipe";
import { CsvDownloadComponent } from "../../UI/csv-download/csv-download.component";

@Component({
    selector: 'app-dashboard-accounts',
    imports: [
    CommonModule,
    RouterModule,
    MomentFormatPipe,
    CsvDownloadComponent
],
    templateUrl: './dashboard-accounts.component.html',
    styleUrl: './dashboard-accounts.component.scss'
})
export class DashboardAccountsComponent {
    public section: string
    public newRequests: AccountRequest[] | undefined
    public newRequestsCsv: any
    // public hashmap: Map<string, AccountRequest[]> = new Map();
    public hashmap = signal<Map<string, AccountRequest[]>>(new Map());


    public dateList: string[] | undefined

    public loaded: boolean

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public authService: AuthService
    ) {
        this.section = "requests"
        this.dateList = []
        this.loaded = true

        this.authService.getLatestRequests(20).subscribe(res => {
            // this.loaded = false
            // this.hashmap.update(currentMap => {
            //     const newMap = new Map(); // Create a new Map from the current one

            //     return newMap; // Return the new Map instance
            // });


            this.newRequests = res
            this.newRequestsCsv = this.newRequests.map(item => item.getCSV())

            this.hashmap.update(currentMap => {
                const newMap = new Map(currentMap); // Create a new 
                newMap.clear()
                return newMap; // Return the new Map instance
            });

            res.forEach(request => {
                var itemDate = moment(request.date.toDate()).format('dddd, MMMM D, YYYY')
                if (!this.dateList?.includes(itemDate)) {
                    this.dateList?.push(itemDate)
                }
                var list = this.hashmap().get(itemDate)
                if (list == undefined || list == null) {
                    list = []
                }
                list.push(request)

                // setTimeout(() => {
                // this.loaded = true
                this.hashmap.update(currentMap => {
                    const newMap = new Map(currentMap); // Create a new Map from the current one
                    if (list) {
                        newMap.set(itemDate, list);
                    }
                    return newMap; // Return the new Map instance
                });
            })
        })
    }

    ngOnInit() {
        this.activatedRoute.paramMap.subscribe(params => {
            const section = params.get('subSection'); // 'id' is the parameter name from your route
            if (section) {
                this.section = section
            }

        });
    }

    approve(request : AccountRequest) {
        this.authService.approveAccountRequest(request)
    }

    deny(request : AccountRequest) {
        this.authService.denyAccountRequest(request)
    }
}
